<template>
  <div class="step">
    <img
      src="/images/satisfaction-survey/woman-photo.png"
      alt="Woman using a tablet"
      class="step__image"
    />
    <div class="step__content">
      <h4 class="step__heading">Help us improve your experience!</h4>
      <p class="step__copy">
        Congratulations on launching your solution! 🎉 We'd love to hear your
        thoughts on our collaboration during this implementation.
      </p>
      <ul class="step__list">
        <li class="step__list-item">
          This 5-question survey will take about 5 minutes
        </li>
        <li class="step__list-item">This survey is not anonymous</li>
      </ul>
      <p class="step__email-disclaimer">
        Sending feedback as
        <span class="step__email-address">{{ email }}</span>
      </p>
    </div>
  </div>
</template>

<script lang="ts" setup>
const { query } = useRoute()
const email = query.email as string
</script>

<style lang="scss" scoped>
.step {
  display: flex;
  flex-direction: column;
  gap: 48px;
  align-items: flex-start;

  @media (min-width: $breakpoint-lg) {
    flex-direction: row;
  }

  &__image {
    width: 100%;
    max-width: 120px;

    @media (min-width: $breakpoint-md) {
      max-width: 150px;
    }
  }

  &__heading {
    margin-bottom: 24px;
  }

  &__copy {
    margin-bottom: 16px;
  }

  &__list {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-bottom: 32px;
  }

  &__list-item {
    display: flex;
    align-items: center;

    &::before {
      @include icon('@/assets/icons/list-tick-cobalt.svg', 24px, 24px);

      content: '';
      flex-shrink: 0;
      display: block;
      margin-right: 8px;
    }
  }

  &__email-disclaimer {
    margin: 0;
  }

  &__email-address {
    text-decoration: underline;
  }
}
</style>
